import React from "react";
import { createPortal } from "react-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { formatCasinoCoin, formatCasinoOutcomeLabel } from "../../utils/casinoHelpers";
import { POCKET_FILL } from "../../utils/roulettePockets";

const BondSpinResultModal = ({
  open = false,
  message = "",
  tone = "success",
  bet = null,
  gameResult = null,
  winAmount = null,
  betAmount = 0,
  onClose,
}) => {
  if (!open) return null;

  const isSuccess = tone === "success";
  const pocketColor = gameResult?.color ? POCKET_FILL[gameResult.color] || gameResult.color : "#888";

  return createPortal(
    <div className="bplay-spin-result-root" role="dialog" aria-modal="true" aria-labelledby="bplay-spin-result-title">
      <button type="button" className="bplay-spin-result-backdrop" aria-label="Close" onClick={onClose} />
      <div className={`bplay-spin-result-sheet tone-${tone}`}>
        <div className={`bplay-spin-result-icon${isSuccess ? " success" : " danger"}`}>
          {isSuccess ? (
            <CheckCircle2 size={28} strokeWidth={2.25} />
          ) : (
            <XCircle size={28} strokeWidth={2.25} />
          )}
        </div>

        <h2 id="bplay-spin-result-title" className="bplay-spin-result-title">
          {message}
        </h2>

        <div className="bplay-spin-result-info">
          <div className="bplay-spin-result-row">
            <span>Your bet</span>
            <strong>{bet?.selectedOutcome ? formatCasinoOutcomeLabel(bet.selectedOutcome) : "—"}</strong>
          </div>
          <div className="bplay-spin-result-row">
            <span>Result</span>
            <span className="bplay-spin-result-pocket">
              {gameResult ? (
                <>
                  <span className="bplay-spin-result-num" style={{ backgroundColor: pocketColor }}>
                    {gameResult.number}
                  </span>
                  <strong>{gameResult.color}</strong>
                </>
              ) : (
                <strong>—</strong>
              )}
            </span>
          </div>
        </div>

        <div className={`bplay-spin-result-outcome${isSuccess ? " win" : " loss"}`}>
          <span>{isSuccess ? "You've won" : "You lost"}</span>
          <strong>
            COIN {isSuccess && winAmount != null ? formatCasinoCoin(winAmount) : `-${formatCasinoCoin(betAmount)}`}
          </strong>
        </div>

        <button type="button" className="bplay-spin-result-btn" onClick={onClose}>
          Continue
        </button>
      </div>
    </div>,
    document.body
  );
};

export default BondSpinResultModal;
